import UECard from "../UECard";
import mascotte_successo from "../../img/mascotte_successo.png"
import { useContext, useEffect } from "react";
import { sendCurrentState, StepContext } from "../StepContext";

function StepSuccesso(){
    const { step, setStep } = useContext(StepContext);
    
    useEffect(()=>{
       /* setTimeout(() => {
            const newWindow = window.open("https://www.umbriaenergy.it", '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null 
        }, 3000);*/

        let conx = {
            step: step,
        };
        StepContext.contratto = { ...StepContext.contratto, ...conx };
        sendCurrentState();

    } ,[]);

    return <UECard mascotte="none">
        <div style={{margin:"0 auto",paddingLeft:"25px",maxWidth:"750px",display:"block",textAlign:"center"}}>
        <h1 style={{color:"green"}}>Benvenuto in Umbria Energy!</h1>
        <h2>Ti abbiamo inviato una email con il contratto da firmare digitalmente, segui le istruzione per completare la richiesta.</h2>
        <br/>
        <br/>
        <h2>Grazie della Fiducia. Ci impegneremo al massimo per prenderci cura delle tue utenze.</h2>
        <img style={{margin:"10px auto",width:"100%",maxWidth:"400px",display:"block" }} src={mascotte_successo}/>
        
        </div>
    </UECard>
}

export default StepSuccesso;